import calendar from './images/calendar-icon.svg';
import chartBarsAscending from './images/chart-bars-ascending.svg';
import chartBarsSun from './images/chart-bars-sun.svg';
import databaseSleeping from './images/database-sleeping.svg';
import databaseStackMagnifier from './images/database-stack-magnifier.svg';
import fileOutline from './images/file-outline.svg';
import folderWithCycle from './images/folder-with-cycle.svg';
import folderWithDocument from './images/folder-with-document.svg';
import folderWithStack from './images/folder-with-stack.svg';
import humanIdentityOutline from './images/human-identity-outline.svg';
import nonHumanIdentityOutline from './images/non-human-identity-outline.svg';
import staleWidgetDuplicated from './images/stale-widget-duplicated.svg';
import staleWidgetStale from './images/stale-widget-stale.svg';
import staleWidgetTotal from './images/stale-widget-total.svg';

/**
 * Shape-named URLs for illustration/icon assets bundled with @dawn/ui.
 * Consumers render these as `<img src={illustrations.xxx} />`.
 * Names describe the visual shape, not the feature currently using them —
 * any consumer can repurpose them.
 */
export const illustrations = {
  calendar,
  chartBarsAscending,
  chartBarsSun,
  databaseSleeping,
  databaseStackMagnifier,
  fileOutline,
  folderWithCycle,
  folderWithDocument,
  folderWithStack,
  humanIdentityOutline,
  nonHumanIdentityOutline,
  staleWidgetTotal,
  staleWidgetDuplicated,
  staleWidgetStale,
} as const;
